import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import type { AppDispatch } from "types/redux-dispatch";

import { closeModal } from "libs/modals";

import { DELETE_USER_MODAL, EDIT_USER_MODAL } from "../../UserModals";

import { useDeleteCollaborationUser } from "../../users-queries";
import { ConfirmWithText } from "ui/modals/ConfirmWithText";

interface DeleteUserTypes {
  email: string;
  accountName: string;
}

const ConfirmText = "delete";

export const DeleteUserModal = (props: DeleteUserTypes) => {
  const { accountName, email } = props;
  const dispatch = useDispatch<AppDispatch>();
  const deleteUserMutation = useDeleteCollaborationUser();

  const closeDeleteModal = () => {
    dispatch(closeModal({ type: DELETE_USER_MODAL }));
  };

  const submit = async () => {
    try {
      await deleteUserMutation.mutateAsync({ email });
      dispatch(closeModal({ type: EDIT_USER_MODAL }));
      dispatch(closeModal({ type: DELETE_USER_MODAL }));
    } catch (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : "There was an error deleting the user."
      );
    }
  };

  return (
    <ConfirmWithText
      closeModal={closeDeleteModal}
      title={`Delete [${accountName}] User`}
      subTitle={`Are you sure you want to delete [${accountName}] from Sked?`}
      defaultConfirmText={ConfirmText}
      confirmButtonText={"Delete"}
      onSubmit={submit}
    >
      <p className="mt-[26px] text-sm font-light leading-[17px]">
        To confirm, enter <i>&lsquo;delete&rsquo;</i> in the field below.
      </p>
    </ConfirmWithText>
  );
};
